<template>
  <div class="fp-preferences-content">
    <div class="third-step">
      <h6>
        {{ $lang.messages.preferences_parenting_schedule_title }}
      </h6>
      <p>
        {{ $lang.messages.preferences_parenting_schedule_text }}
      </p>

      <div>
        <div>
          <p>
            {{ $lang.messages.preferences_parenting_schedule_question }}
          </p>
          <div class="choices">
            <div>
              <label class="radio-wrapper">
                <input type="radio" name="calendar" v-model="parentingSchedule" :value="true">
                <span class="radio-checkmark"></span>
                <span class="radio-label">{{ $lang.messages.preferences_yes }}</span>
              </label>

              <label class="radio-wrapper">
                <input type="radio" name="calendar" v-model="parentingSchedule" :value="false">
                <span class="radio-checkmark"></span>
                <span class="radio-label">{{ $lang.messages.preferences_no }}</span>
              </label>
            </div>
          </div>
          <p>
            {{ $lang.messages.preferences_ok_got_it }}
          </p>
          <p>
            <span>{{ $lang.messages.preferences_parenting_schedule_tip }}</span>
            {{ $lang.messages.preferences_parenting_schedule_description }}
          </p>
        </div>
        <img class="illustration img-fluid" src='@/assets/images/preferences_illustration_calendar.png' />
      </div>
    </div>
    <button type="button" class="generic-btn back-btn" @click="backButtonClick">
      <span>
        {{ $lang.messages.back }}
      </span>
    </button>
    <button type="button" class="action-btn next-btn" @click="finishButtonClick">
      <span>
        {{ $lang.messages.preferences_finish }}
      </span>
    </button>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import {
    POST_PARENTING_SCHEDULE_PREFERENCES,
    SET_PARENTING_SCHEDULE_PREFERENCE_COMPLETED
  } from "@/store/action.types";

  export default {
    name: "PreferencesCalendar",
    props: {
      backButtonClick: {
        type: Function,
        required: true
      },
      toWelcomeScreenBtn: {
        type: Function,
        required: true
      }
    },
    data() {
      return {
        parentingSchedule: true
      }
    },
    methods: {
      ...mapActions({
        parentingSchedulePreferencesAction: POST_PARENTING_SCHEDULE_PREFERENCES,
        setParentingSchedulePreferencesAction: SET_PARENTING_SCHEDULE_PREFERENCE_COMPLETED,
      }),
      /**
       * @description Method sends request to BE to save data for parenting schedule preference
       * When request is success, it saves parentingSchedule prop to store and emit finishButtonClick
       */
      finishButtonClick() {
        this.parentingSchedulePreferencesAction({
          parentingSchedule: this.parentingSchedule
        })
        .then(() => {
          this.toWelcomeScreenBtn();
          this.setParentingSchedulePreferencesAction(true);
        })
        .catch(() => {
          this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
        });
      },
    }
  }
</script>
